import ColorLegend from './ColorLegend';
import OrganizerContacts from './OrganizerContacts';
import StandingsTable from './StandingsTable';
import { GameTypes } from '../utils/enums';
import { reportTitle } from '../utils/misc';
import { useDivisions } from '../utils/hooks';
import { useFirebase } from './FirebaseContextProvider';
import './StandingsPDF.scss';

export default function StandingsPDF({ id, colorLegend }) {
  const { tournamentsById } = useFirebase();
  const tournament = tournamentsById.get(id);
  const divisions = useDivisions(id);

  return (
    <div className='standings-pdf'>
      <>
        <h4 className={'title'}>{reportTitle(tournament)}</h4>
        <OrganizerContacts org={tournament?.organizations?.[0]} print />
        <ColorLegend
          id={id}
          colorLegend={Object.fromEntries(
            Object.entries(colorLegend).map(([k, v]) => [
              k,
              { ...v, color: v.color + '50' },
            ])
          )}
        />
      </>
      {divisions.map((div, i) => (
        <div className={'division' + (i === 0 ? '' : ' new-page')} key={div}>
          <h3 className='header-division'>{div}</h3>
          <StandingsTable
            id={id}
            division={div}
            gameType={GameTypes.POOLGAME}
            title='Pool games'
            colorLegend={colorLegend}
          />
          <StandingsTable
            id={id}
            division={div}
            gameType={GameTypes.PLAYOFF}
            title='Playoff games'
            colorLegend={colorLegend}
            hideWhenEmpty
          />
        </div>
      ))}
    </div>
  );
}
